/**
 * Query key factory for pots
 * Following the pattern from potPeriodKeys.ts
 */

export const potKeys = {
  all: ['pots'] as const,
  lists: () => [...potKeys.all, 'list'] as const,
  list: (potPeriodId: string, search?: string) =>
    [...potKeys.lists(), potPeriodId, search || undefined] as const,
  details: () => [...potKeys.all, 'detail'] as const,
  detail: (potId: string) => [...potKeys.details(), potId] as const,
};
